import type { FeatureStatus } from "@/types/content";
import { statusLabels } from "@/types/content";
import "./StatusBadge.css";

const iconFor: Record<FeatureStatus, string> = {
  live: "●",
  pilot: "●",
  "in-development": "◐",
  planned: "○",
};

export function StatusBadge({ status }: { status: FeatureStatus }) {
  return (
    <span className={`status-badge status-badge-${status}`}>
      <span aria-hidden="true">{iconFor[status]}</span>
      {statusLabels[status]}
    </span>
  );
}
